module.exports = __webpack_public_path__ + "static/media/mosquito-tech.1dfdd39f.svg";